module.exports = __webpack_public_path__ + "img/yishouwan.3270753c.png";